import { Component } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';

declare var MediaRecorder: any;

/**
 * Generated class for the AudioCaptureComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'audio-capture',
  templateUrl: 'audio-capture.html'
})
export class AudioCaptureComponent {

  text: string;
  recorder;
  chunks;
  stream;

  constructor(public events: Events, private toastCtrl: ToastController) {
  }


  recordAudio() {
    this.chunks = [];
    navigator.mediaDevices.getUserMedia({ audio: true }).then(_stream => {
      console.log('got media');
      this.stream = _stream;
      this.recorder = new MediaRecorder(this.stream);
      this.recorder.ondataavailable = e => {
        this.chunks.push(e.data);
        this.saveRecording();
      }
      this.recorder.start();
      console.log('started recording');
      document.getElementById('btnStartRec').hidden = true;
      document.getElementById("btnStopRec").hidden = false;
    }).catch(err => {
      let toast = this.toastCtrl.create({
        message: "Es gab einen Fehler beim aufzeichnen! " + err,
        duration: 5000,
        position: 'bottom'
      });
      toast.present();
      console.error("Es gab einen Fehler beim aufzeichnen! " + err);
    });
  }

  saveRecording() {
    let blob = new Blob(this.chunks, { type: 'audio/ogg' })
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      var base64data = reader.result;
      document.getElementById("btnStartRec").hidden = false;
      document.getElementById('btnStopRec').hidden = true;
      document.getElementById('audioPlayer').setAttribute("src", base64data.toString());
      this.events.publish('audiocaptured', base64data);
    }
    this.stopAudioMediaDevice();
  }

  stopRecordAudio() {
    this.recorder.stop();
  }

  stopAudioMediaDevice() {
    this.stream.getTracks().forEach(function (track) {
      if (track.readyState == 'live' && track.kind === 'audio') {
        track.stop();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/audio-capture/audio-capture.ts